import React from "react";

const blogs = [
  {
    img: "/images/keyword/114.jpg",
    title: "Mumbai Outstation Cabs",
    link: "/Mumbai-Outstation-Cabs",
    comments: "2 Comments",
    date: "25 MAR",
    text: "Book Mumbai outstation cabs for safe, comfortable, and affordable travel to destinations across Maharashtra and India.",
  },
  {
    img: "/images/keyword/112.jpg",
    title: "Mumbai to Goa Cabs",
    link: "/Mumbai-to-Goa-Cabs",
    comments: "2 Comments",
    date: "25 MAR",
    text: "Hire a Mumbai to Goa cab service for a hassle-free road trip with professional drivers and well-maintained vehicles.",
  },
  {
    img: "/images/keyword/108.jpg",
    title: "Mumbai to Pune Cab",
    link: "/Mumbai-to-Pune-Cab",
    comments: "2 Comments",
    date: "25 MAR",
    text: "Travel comfortably with our Mumbai to Pune cab service offering one-way, round-trip, and airport transfer options.",
  },
];

const BlogSection = () => {
  return (
    <section className=" space-extra-bottom blog-wrapper p-0 py-3">
      <div className="container">
        {/* Section Title */}
        <div className="row justify-content-center text-center">
          <div className="col-xl-7 col-lg-8">
            <div className="title-area">
              <span className="sec-subtitle">Popular Cab Services</span>
              <h2 className="sec-title h1">
                Explore Our Most Booked Taxi Services
              </h2>
            </div>
          </div>
        </div>

        {/* Blog Cards */}
        <div className="row g-4">
          {blogs.map((blog, index) => {
            const [day, month] = blog.date.split(" ");

            return (
              <div className="col-xl-4 col-md-6" key={index}>
                <div className="vs-blog blog-style6">
                  {/* Blog Image */}
                  <div className="blog-img">
                    <a href={blog.link}>
                      <img
                        src={blog.img}
                        alt={blog.title}
                        className="img-fluid"
                      />
                    </a>
                  </div>

                  {/* Blog Content */}
                  <div className="blog-content">
                    <div className="blog-body">
                      {/* Meta */}
                      <div className="blog-top">
                        <a className="blog-meta" href={blog.link}>
                          Mumbai Airport Cabs
                        </a>

                        {/* <a className="blog-meta" href={blog.link}>
                          {blog.comments}
                        </a> */}
                      </div>

                      {/* Title */}
                      <h2 className="blog-title h4">
                        <a href={blog.link}>{blog.title}</a>
                      </h2>

                      {/* Description */}
                      <p className="blog-text">{blog.text}</p>

                      {/* Footer */}
                      {/* <div className="blog-bottom">
                        <a className="blog-link" href={blog.link}>
                          Read More
                        </a>

                        <a className="blog-date" href={blog.link}>
                          <span>{day}</span> {month}
                        </a>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;